<template>
  <div class="home">
    <div class="main-section">
      <img class="axe-logo" src="../assets/images/ax_main.svg" alt="American Xchange Logo" width="500">
    </div>

    <div class="slogan">
      <h3 class="title is-uppercase">Technology for all</h3>
    </div>
      <div class="coming-soon">
        <h3 class="subtitle is-uppercase">Website coming soon</h3>
      </div>
  </div>
</template>

<script>
export default {
  name: 'home'
}
</script>
<style lang="scss">
.home {
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  height: 100%;
  flex-direction: column;
  flex-wrap: no-wrap;
  p, h5 {
    font-weight: bold;
  }
  h3 {
    font-weight: 300;
    letter-spacing: 0.30rem;
    color: #fff;
    text-shadow: 3px 3px 2px rgba(0, 0, 0, 0.5);
  }
  .slogan, .coming-soon {
    padding: 20px 0;
  }
  .slogan h3{
    @media screen and (max-width: 700px) {
      font-size: 1.75em;
      text-align: center;
    }
  }
  .main-section {
    -webkit-filter: drop-shadow( 3px 3px 2px rgba(0, 0, 0, .7));
    filter: drop-shadow( 3px 3px 2px rgba(0, 0, 0, .7));
    @media screen and (max-width: 700px) {
      padding: 15px;
    }
  }
}
</style>
